// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"998":"b6eb281abf529fbc","1727":"e62459e1fb6c5bca"}[chunkId] + ".js";
};